module.exports = __webpack_public_path__ + "static/media/longitude.64a3d0da.png";